import { CSSProperties } from "react";
import styles from "./DefectAreaOverlay.module.scss";

interface DefectAreaMaskProps {
  // Context box side in displayed px
  marginSize: number;
  marginRadius: number;
  // Displayed image rect; the mask fills its parent when omitted
  imageWidth?: number;
  imageHeight?: number;
  imageRadius?: number;
}

// Dims everything outside the centered context box
const DefectAreaMask = ({
  marginSize,
  marginRadius,
  imageWidth,
  imageHeight,
  imageRadius,
}: DefectAreaMaskProps) => {
  if (marginSize <= 0) return null;
  const maskStyle: CSSProperties | undefined =
    imageWidth && imageHeight
      ? {
          inset: "auto",
          top: "50%",
          left: "50%",
          width: imageWidth,
          height: imageHeight,
          transform: "translate(-50%, -50%)",
          borderRadius: imageRadius,
        }
      : undefined;

  return (
    <div className={styles.mask} style={maskStyle}>
      <div
        className={styles.marginBox}
        style={{
          width: marginSize,
          height: marginSize,
          borderRadius: marginRadius,
        }}
      />
    </div>
  );
};

export default DefectAreaMask;
